import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LightboxComponent } from './Lightbox.component';

@NgModule({
  imports: [
    // Minga dependencies

    // External dependencies
    CommonModule,
  ],
  declarations: [LightboxComponent],
  exports: [LightboxComponent],
})
export class LightboxModule {}
